module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/gabriel-neely-ac1142b114687b9ecb703abbb169eaf9.webp";